import { getVgPositionChannel } from '../../../channel';
import * as log from '../../../log';
import { isSignalRef } from '../../../vega.schema';
import { getMarkPropOrConfig } from '../../common';
var ALIGNED_X_CHANNEL = {
  left: 'x',
  center: 'xc',
  right: 'x2'
};
var BASELINED_Y_CHANNEL = {
  top: 'y',
  middle: 'yc',
  bottom: 'y2'
};
export function vgAlignedPositionChannel(channel, markDef, config) {
  var defaultAlign = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'middle';
  if (channel === 'radius' || channel === 'theta') {
    return getVgPositionChannel(channel);
  }
  var alignChannel = channel === 'x' ? 'align' : 'baseline';
  var align = getMarkPropOrConfig(alignChannel, markDef, config);
  var alignExcludingSignal;
  if (isSignalRef(align)) {
    log.warn(log.message.rangeMarkAlignmentCannotBeExpression(alignChannel));
    alignExcludingSignal = undefined;
  } else {
    alignExcludingSignal = align;
  }
  // FIXME: remove as any
  if (channel === 'x') {
    return ALIGNED_X_CHANNEL[alignExcludingSignal || (defaultAlign === 'top' ? 'left' : 'center')];
  } else {
    return BASELINED_Y_CHANNEL[alignExcludingSignal || defaultAlign];
  }
}